const documentTypes = [
  {
    text: 'DNI',
    value: 'DNI',
  },
  {
    text: 'Pasaporte',
    value: 'PA',
  },
  {
    text: 'CE',
    value: 'CE',
  },
];

export default documentTypes;
